import { api } from 'services/api';

export class BillingService {
  async getReportInvoicing(inputDate, outputDate, range) {
    return api.get(`/billing/bilingReport/${inputDate}/${outputDate}/${range}`);
  }
}

export const billingService = new BillingService();
